import moment from 'moment';
import { capitalize } from '@shared/utils/strings';
import { getMonthBetweenDates } from '@shared/date/date-utils';
import { MONTHS_TO_BE_CONSIDERED_NOT_TRIAL } from './header-bottom-constants';

export const dayBetweenFromWaitingList = (waitingList) => {
    const today = moment();
    const { trial_expiration_date: trialExpirationDate } = waitingList;
    const daysBetween = today.to(trialExpirationDate, true);
    return capitalize(daysBetween);
};

export const checkWaitingListTrial = (waitingList) => {
    const trialExpirationDate = waitingList.trial_expiration_date;

    const startDate = new Date();
    const endDate = new Date(trialExpirationDate);
    const diffInMonths = getMonthBetweenDates(startDate, endDate);

    return MONTHS_TO_BE_CONSIDERED_NOT_TRIAL > diffInMonths;
};

export const formatUpgradeButtonWithTrial = (waitingList, upgradeLabel) => {
    if (waitingList.is_expired) {
        return upgradeLabel;
    }

    const daysRemaining = dayBetweenFromWaitingList(waitingList);

    return `Trial | ${daysRemaining} Left | ${upgradeLabel}`;
};
